import SvgIcon from "./IconPharmacyIllustration.svg?react";
const IconPharmacyIllustration = SvgIcon;
export default IconPharmacyIllustration;
